import { GeoStateType } from './generated/graphql-types'

/**
 * was from the
 * query getAllStates {
 *  getAllStates {
 *    results {
 *      id
 *      slug
 *      name
 *      code
 *      }
 *    }
 *  }
 */
export const states: Pick<GeoStateType, 'id' | 'slug' | 'name' | 'code'>[] = [
  {
    id: 'f933efeb-387c-4e15-b385-126b2ea6517d',
    slug: 'ca',
    name: 'California',
    code: 'CA',
  },
  {
    id: '2ea6b75b-337e-4dd6-94db-fd30c2262221',
    slug: 'tx',
    name: 'Texas',
    code: 'TX',
  },
  {
    id: 'a63fc698-c58c-48aa-8eae-7a1ff6db4400',
    slug: 'fl',
    name: 'Florida',
    code: 'FL',
  },
  {
    id: 'f30ee0e8-689d-4b31-90ad-0fe1e19c637f',
    slug: 'ny',
    name: 'New York State',
    code: 'NY',
  },
  {
    id: '5c91150f-0705-4a60-8b7d-42d8cfdfef14',
    slug: 'pa',
    name: 'Pennsylvania',
    code: 'PA',
  },
  {
    id: 'c5e8e6cc-d5b0-458c-a631-1161ed3b2295',
    slug: 'il',
    name: 'Illinois',
    code: 'IL',
  },
  {
    id: '3f9a9d95-dd03-40f8-9c85-51902400bb12',
    slug: 'oh',
    name: 'Ohio',
    code: 'OH',
  },
  {
    id: '809dcfad-ef2d-4911-ae2b-cb86f385ff3b',
    slug: 'ga',
    name: 'Georgia',
    code: 'GA',
  },
  {
    id: '1447507c-3115-4475-af53-230a85aa6275',
    slug: 'nc',
    name: 'North Carolina',
    code: 'NC',
  },
  {
    id: '5f51b422-e0a3-400c-b2d2-600e0bd4a59c',
    slug: 'mi',
    name: 'Michigan',
    code: 'MI',
  },
  {
    id: '59eab3fe-d2a3-4ba9-90e2-5801804f0846',
    slug: 'nj',
    name: 'New Jersey',
    code: 'NJ',
  },
  {
    id: 'c1f2c5d9-05d3-4503-b2a9-63357102713f',
    slug: 'va',
    name: 'Virginia',
    code: 'VA',
  },
  {
    id: '8a70559f-74a0-40c7-9ec6-aea1611d645c',
    slug: 'wa',
    name: 'Washington',
    code: 'WA',
  },
  {
    id: '287d1b71-32ea-41b6-9057-8aafc785e0a9',
    slug: 'az',
    name: 'Arizona',
    code: 'AZ',
  },
  {
    id: 'f6030cab-041a-474e-8995-5e88ab8501e6',
    slug: 'ma',
    name: 'Massachusetts',
    code: 'MA',
  },
  {
    id: '2eaccb70-0b97-455d-919b-3e7d82e60757',
    slug: 'tn',
    name: 'Tennessee',
    code: 'TN',
  },
  {
    id: 'eb5cb3b8-85f8-4520-a813-9340b53d98eb',
    slug: 'in',
    name: 'Indiana',
    code: 'IN',
  },
  {
    id: '999041e9-49f2-4278-a3c7-b9233aa27c6e',
    slug: 'md',
    name: 'Maryland',
    code: 'MD',
  },
  {
    id: '27dd5453-4714-4008-9c4c-f4b71917c915',
    slug: 'mo',
    name: 'Missouri',
    code: 'MO',
  },
  {
    id: '5cc2eacf-5e17-42e2-8de5-5cf4844055c4',
    slug: 'wi',
    name: 'Wisconsin',
    code: 'WI',
  },
  {
    id: 'c9f5fa9d-36f1-424b-b651-7c521d94b5fb',
    slug: 'co',
    name: 'Colorado',
    code: 'CO',
  },
  {
    id: '6678267f-09a6-4f6b-8bb4-f195573fc7d3',
    slug: 'mn',
    name: 'Minnesota',
    code: 'MN',
  },
  {
    id: '66741160-d099-47f2-9b8b-0fd1d40f5e09',
    slug: 'sc',
    name: 'South Carolina',
    code: 'SC',
  },
  {
    id: '95f5b41a-1e5d-4e30-b664-7d045f58167a',
    slug: 'al',
    name: 'Alabama',
    code: 'AL',
  },
  {
    id: '7d251d77-12b9-43f8-8721-33fc9e370520',
    slug: 'la',
    name: 'Louisiana',
    code: 'LA',
  },
  {
    id: 'a965b328-88f9-48e6-8a5c-035807b753e8',
    slug: 'ky',
    name: 'Kentucky',
    code: 'KY',
  },
  {
    id: '84009c20-e668-4bbb-b271-57658abba567',
    slug: 'or',
    name: 'Oregon',
    code: 'OR',
  },
  {
    id: '0679ba34-9b3d-4e2f-8519-8ccc5119bd25',
    slug: 'ok',
    name: 'Oklahoma',
    code: 'OK',
  },
  {
    id: '0e1a5b31-e291-45a0-953d-0ab540c323c9',
    slug: 'ct',
    name: 'Connecticut',
    code: 'CT',
  },
  {
    id: 'c82fc65d-2e48-47a3-804c-af1fe8c35b61',
    slug: 'pr',
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    id: 'a0336df8-b81e-4e4f-bfb7-035ae1b98381',
    slug: 'ut',
    name: 'Utah',
    code: 'UT',
  },
  {
    id: '28257b65-a1f4-413f-8973-7fb57321eed9',
    slug: 'ia',
    name: 'Iowa',
    code: 'IA',
  },
  {
    id: 'b89eb597-46cf-4507-b857-f8d3fd901505',
    slug: 'nv',
    name: 'Nevada',
    code: 'NV',
  },
  {
    id: 'c5107f6b-426f-4563-80aa-a5012de5f9c6',
    slug: 'ar',
    name: 'Arkansas',
    code: 'AR',
  },
  {
    id: '478e0fe8-edd8-4952-8908-1622721bea4c',
    slug: 'ms',
    name: 'Mississippi',
    code: 'MS',
  },
  {
    id: '85fe6901-deb7-4dd6-8e84-85a5fd2f7d0d',
    slug: 'ks',
    name: 'Kansas',
    code: 'KS',
  },
  {
    id: '600c9ee6-6dd5-4696-862c-c024b288bfbf',
    slug: 'nm',
    name: 'New Mexico',
    code: 'NM',
  },
  {
    id: 'e4339e38-9dbe-4edd-bc69-2d45136015ed',
    slug: 'ne',
    name: 'Nebraska',
    code: 'NE',
  },
  {
    id: 'd8308e5e-8207-45d7-8a12-afa975e59847',
    slug: 'id',
    name: 'Idaho',
    code: 'ID',
  },
  {
    id: '1bc6667e-36f1-4d6f-8df6-84fc4bf79bf4',
    slug: 'wv',
    name: 'West Virginia',
    code: 'WV',
  },
  {
    id: '80c6481a-0467-4429-b604-991c202df629',
    slug: 'hi',
    name: 'Hawaii',
    code: 'HI',
  },
  {
    id: '90388bb8-8f90-4828-94d7-a2e348653db6',
    slug: 'nh',
    name: 'New Hampshire',
    code: 'NH',
  },
  {
    id: 'b8cc1867-1f63-4342-a275-93b4cf93de95',
    slug: 'me',
    name: 'Maine',
    code: 'ME',
  },
  {
    id: '8f28ac74-a4c8-4ac2-b295-11c4d620a916',
    slug: 'ri',
    name: 'Rhode Island',
    code: 'RI',
  },
  {
    id: '1f073088-60db-4929-b201-3093445986e8',
    slug: 'mt',
    name: 'Montana',
    code: 'MT',
  },
  {
    id: 'c9f5c534-05b8-410b-adfd-e310b3f62ac7',
    slug: 'de',
    name: 'Delaware',
    code: 'DE',
  },
  {
    id: 'cf5f69e3-a56e-4af9-9d9f-18540be01401',
    slug: 'sd',
    name: 'South Dakota',
    code: 'SD',
  },
  {
    id: 'a6d0da5d-412b-4eca-a273-0e610b1f4833',
    slug: 'nd',
    name: 'North Dakota',
    code: 'ND',
  },
  {
    id: '7fd6992c-3612-4b8b-802b-d00c33ec5530',
    slug: 'ak',
    name: 'Alaska',
    code: 'AK',
  },
  {
    id: '84347199-1846-4349-b6d8-9a95fe9dc3a7',
    slug: 'dc',
    name: 'District of Columbia',
    code: 'DC',
  },
  {
    id: '720624aa-10de-4ce1-9e45-8c6d2a710ed3',
    slug: 'vt',
    name: 'Vermont',
    code: 'VT',
  },
  {
    id: '980975b0-4f1e-4323-8793-05209736114c',
    slug: 'wy',
    name: 'Wyoming',
    code: 'WY',
  },
  {
    id: 'a4396cf1-aa45-4916-a6d5-0a82a0dcf843',
    slug: 'gu',
    name: 'Guam',
    code: 'GU',
  },
  {
    id: 'fa7b2159-5258-417b-987f-10a7983e3b0f',
    slug: 'vi',
    name: 'Virgin Islands',
    code: 'VI',
  },
  {
    id: 'aaaf1777-3fd9-4252-8872-9f8f85492243',
    slug: 'as',
    name: 'American Samoa',
    code: 'AS',
  },
  {
    id: 'b208d1dc-4786-4427-aa3d-192a2f4d83bc',
    slug: 'mp',
    name: 'Northern Mariana Islands',
    code: 'MP',
  },
]
